import { Col, Row } from 'antd';
import React, { PureComponent } from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import Map from './Map';

const styles = () => ({
  root: {
    backgroundColor: '#454545',
    color: '#FFFFFF',
    padding: '2em',
  },
  text: {
    paddingBottom: '1em',
  },
  contactInfos: {
    marginTop: '1em',
  },
});

const data = {
  address: `5 place Hubert Dubedout

Grenoble`,
  phone: '07 88 80 71 25',
  email: 'paulinelaborieavocat@gmail.com',
};
class Location extends PureComponent {
  render() {
    const { classes } = this.props;

    const renderText = (title, content) => (
      <div className={classes.text}>
        <strong>{title}</strong>
        {content.split('38 000').map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    );
    const { address, phone, email } = data;

    return (
      <Row type="flex" justify="center" className={classes.root}>
        <Col span={18}>
          <Row type="flex" justify="start" gutter={24}>
            <Col md={12} xs={24}>
              <Map />
            </Col>
            <Col md={8} xs={24} className={classes.contactInfos}>
              {renderText('Adresse', address)}
              {renderText('Téléphone', phone)}
              {renderText('Email', email)}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default injectSheet(styles)(Location);



// WEBPACK FOOTER //
// ./src/app/pages/contact/components/Location.jsx